enum MessageStatus {
    Queued = 'Queued',
    Sent = 'Sent',
    Failed = 'Failed'
}


export default MessageStatus;